export const getNormalizedScore = (score: number, totalScore: number) => {
	if (!totalScore) {
		return 0;
	}
	return (score / totalScore) * 100;
};

export type BlankValuesResponse = Record<string, string>;

export const isBlankValuesResponse = (
	value: unknown,
): value is BlankValuesResponse => {
	if (typeof value !== "object" || value === null || Array.isArray(value)) {
		return false;
	}

	return Object.values(value).every((entry) => typeof entry === "string");
};

export const getBlankValuesResponse = (
	userResponse: Record<string, unknown> | undefined,
	itemId: number,
): BlankValuesResponse | undefined => {
	const value = userResponse?.[itemId];
	return isBlankValuesResponse(value) ? value : undefined;
};

// Empty entries are pruned so the persisted map never claims a blank the
// learner cleared.
export const toPersistableBlankValues = (
	values: Record<string, string>,
): BlankValuesResponse | undefined => {
	const filled = Object.entries(values).filter(
		([, value]) => value.trim() !== "",
	);
	return filled.length ? Object.fromEntries(filled) : undefined;
};
